import { createRef, RefObject, useMemo } from 'react';
import { SelectInstance } from 'react-select';

import useDimensionsObserver from '@/utils/use-dimensions-observer';

const useTrackReactSelectInputDimensions = (selectRef?: RefObject<SelectInstance | null> | null) => {
  const controlAsReactRef = useMemo(() => {
    const selectInstance = selectRef?.current;
    const controlEl = (selectInstance?.controlRef || null) as HTMLDivElement | null;
    const _controlRef = createRef<HTMLDivElement | null>();
    _controlRef.current = controlEl;

    return _controlRef;
    // we must include selectRef.current or we'll always get null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRef?.current]);

  const inputDimensions = useDimensionsObserver({ ref: controlAsReactRef });

  return useMemo(() => inputDimensions, [inputDimensions]);
};

export default useTrackReactSelectInputDimensions;
